import { Box as BaseBox } from 'components/Box/Box';
import React, { memo, Suspense, useEffect, useState } from 'react';
import { DEFAULT_CENTER_COORDS } from '../../constants';
import { Coords, LocationOnMap } from '../../type.d';
import LocationMarker from './LocationMarker';
import getRightLngLat from './getRightLngLat';
import useConvertPlusCodeToCoords from './hooks/useConvertPlusCodeToCoords';
import useMapContainer from './hooks/useMapContainer';
import LoadingIndicator from 'components/LoadingIndicator';
interface Props {
  locations: LocationOnMap[];
  coords: Coords | null;
  selectedLocation: string;
}

const Map = ({ locations, selectedLocation }: Props) => {
  const [selectedLocationDetails, setSelectedLocationDetails] = useState<{
    locationObject: LocationOnMap | undefined;
    convertedCoords: Coords | null;
  }>({ locationObject: undefined, convertedCoords: null });

  const selectedLocationCoords = locations.find((location) => location.id === selectedLocation);

  const plusCode = selectedLocationCoords?.plus_code ?? '';

  const coordsFromPlusCode = useConvertPlusCodeToCoords(plusCode);

  useEffect(() => {
    setSelectedLocationDetails({
      locationObject: selectedLocationCoords,
      convertedCoords: coordsFromPlusCode,
    });
  }, [selectedLocationCoords, coordsFromPlusCode]);

  const coordsFromSelectedLocation =
    selectedLocationDetails.convertedCoords || selectedLocationDetails.locationObject?.coords;
  const center =
    locations.length === 1 ? getRightLngLat(locations[0].coords) : getRightLngLat(coordsFromSelectedLocation);
  const { mapContainer, ref } = useMapContainer(center ?? DEFAULT_CENTER_COORDS);
  return (
    <BaseBox loading={false} style={{ height: '625px' }} ref={ref}>
      {mapContainer ? (
        <Suspense fallback={<LoadingIndicator />}>
          <LocationMarker locations={locations} map={mapContainer} />
        </Suspense>
      ) : null}
    </BaseBox>
  );
};

export default memo(Map);
